export default __webpack_public_path__ + "static/media/199.54738526.png";